<template>
  <div>
    <link rel="stylesheet" href="css/transporation.css"/>
    <div>
        <HeaderOfPage :bgSrc="'banner-transportation.jpg'" :theDiscription="'النقل'" :titleOfPage="'النقل السياحي'"/>
    </div>
    <section class="pages-container">
      <b-container>
        <b-row>
          <b-col sm="3" cols="6" v-for="g in 6" :key="g">
            <SingleTransportCard/>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="pagination">
            <b-pagination
              
              :total-rows="5"
              :per-page="1"
              first-number
              last-number
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage from '../global/HeaderOfPage'
  import SingleTransportCard from './SingleTransportCard'
  export default {
    name:'Transportations',
    components: {
      HeaderOfPage,
      SingleTransportCard
    }
  }
</script>
